import PromotionsAnnouncement from './PromotionsAnnouncement';
export default PromotionsAnnouncement;
